import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getPolicyDocument } from '../../services/policyService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import GeneralTab from './tab-pages/GeneralTab';
import QuizTab from './tab-pages/QuizTab';
import AssignmentsTab from './tab-pages/AssignmentsTab';
import StatsTab from './tab-pages/StatsTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function PolicyDocumentDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [doc, setDoc] = useState(null);
  const [activeTab, setActiveTab] = useState('general');

  useEffect(() => {
    getPolicyDocument(id)
      .then((res) => setDoc(res.data?.data));
  }, [id]);

  const docTitle = doc ? doc.title : '...';

  const tabs = [
    { key: 'general', label: t('policy.general') },
    { key: 'quiz', label: t('policy.quiz') },
    { key: 'assignments', label: t('policy.assignments') },
    { key: 'stats', label: t('policy.stats') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('policy.documents'), path: '/policy-documents' },
          { label: docTitle },
        ]} />
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'general' && <GeneralTab documentId={id} />}
        {activeTab === 'quiz' && <QuizTab documentId={id} />}
        {activeTab === 'assignments' && <AssignmentsTab documentId={id} />}
        {activeTab === 'stats' && <StatsTab documentId={id} />}
      </TabContent>
    </PageContainer>
  );
}
